export default __webpack_public_path__ + "30ad7dd91d14036daca89db665568874.png";